<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {};
  },
  beforeDestroy() {
    if (this.$store.hasModule("Financial"))
      this.$store.unregisterModule("Financial");
  },
};
</script>

<style lang="scss"></style>
